@use 'src/styles/variables-bundle' as *;
@use 'src/templates/components/global/accessibility';

:host {
  display: block;
}

ents-carousel-container {
  text-align: left;
}

[data-ents-cart-favorites-tracker] {
  display: block;
  width: 1px;
  height: 1px;
}

.ents-cart-favorites-product {
  display: inline-block;
  text-align: center;

  &__inner {
    position: relative;
  }

  &__wishlist-button {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 3;
  }

  &__link {
    display: block;
    color: color('coal-100');

    &:hover {
      color: inherit;
    }
  }

  &__image-container {
    position: relative;
    display: block;
  }

  &__ai-badge {
    position: absolute;
    bottom: spacer(3);
    left: spacer(3);
    z-index: 2;
    cursor: default;
  }

  &__image {
    width: 100%;
    height: auto;
  }

  &__details {
    display: block;
    padding-top: 0;
  }

  &__brand,
  &__name,
  &__sub-name {
    display: block;
  }
}

.ents-cart-favorites {
  display: block;
  padding-bottom: spacer(10);

  &--hidden {
    display: none;
  }

  &[data-ents-cart-favorites-slide-count='0'] {
    display: none;
  }

  [data-ents-cart-favorites-slide-count='0'] & {
    display: none;
  }

  &__slider-container {
    @include up_to_S {
      margin-left: spacer(-3);
      margin-right: spacer(-3);
    }

    @include S_to_M {
      margin-left: spacer(-4.5);
      margin-right: spacer(-4.5);
    }
  }

  &__product {
    width: 100%;
    overflow-wrap: break-word;
    text-align: left;

    .ents-cart-favorites-product {
      &__details {
        margin-top: spacer(3);
      }
    }

    camp-aktionsflag[contains-flag='true'] {
      display: inline-block;
      margin-top: spacer(3);
    }

    camp-aktionsflag[contains-flag='false'] {
      display: none;
      margin-top: 0;
    }
  }

  .ents-cart-favorites-product__brand,
  .ents-cart-favorites-product__name-container {
    margin-bottom: spacer(1);
  }

  ents-carousel {
    @include up_to_M {
      margin-right: calc(var(--bdk-main-margin) * -1);
    }

    --aspect-ratio: 41/56;
    --num-slides: 2.5;

    @include M_and_up {
      --num-slides: 3.5;
    }

    // XL + page margin
    @media all and (min-width: 1232px) {
      --num-slides: 4.5;
    }

    // XXL + page margin
    @media all and (min-width: 1432px) {
      --num-slides: 6.5;
    }

    // XXXL + page margin
    @media all and (min-width: 1804px) {
      --num-slides: 7.5;
    }

    img,
    svg {
      aspect-ratio: var(--aspect-ratio, 41 / 56) !important;
      object-fit: cover;
      max-width: 100%;
    }

    article {
      a {
        color: color('coal-100');

        &:hover {
          color: inherit;
        }
      }
    }
  }
}

.carousel-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  align-items: end;
  margin-bottom: spacer(4);

  &--heading {
    margin-right: spacer(1);
    width: 100%;
  }

  &--navigation {
    display: none;

    @include L_and_up {
      display: flex;
      flex-direction: row;
      place-items: center;
      justify-content: space-between;
      gap: spacer(3);
    }

    button {
      &:disabled,
      &[disabled] {
        color: color('smoke');
        cursor: default;
      }
    }
  }
}

.ents-badge {
  display: inline-block;
  text-align: left;
  width: auto;
  line-height: 19px;
  margin: 0;
  padding: 0 spacer(1);

  &__cart-favorites {
    position: absolute;
    top: spacer(1);
    margin-left: spacer(1);
  }
}
